"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.RAIL_WIDTH_CONDENSED = exports.RAIL_WIDTH = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var DrawerLayoutContextProvider_1 = require("../DrawerLayout/contexts/DrawerLayoutContextProvider");
var DrawerContext_1 = require("./DrawerContext");
var types_1 = require("./types");
var utilities_1 = require("./utilities");
var clsx_1 = __importDefault(require("clsx"));
exports.RAIL_WIDTH = 'calc(3.5rem + 16px)'; // 72;
exports.RAIL_WIDTH_CONDENSED = 'calc(1.5rem + 32px)'; //56;
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: {
            transition: theme.transitions.create('width', { duration: theme.transitions.duration.leavingScreen }),
            minHeight: '100%',
            backgroundColor: function (props) { return props.backgroundColor || 'transparent'; },
            '&$expanded': {
                transition: theme.transitions.create('width', {
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
        },
        expanded: {},
        paper: {
            overflow: 'hidden',
            position: 'inherit',
            boxShadow: theme.shadows[4],
            borderWidth: 0,
            '&$sideBorder': {
                borderWidth: 1,
                boxShadow: 'none',
            },
        },
        sideBorder: {},
    });
});
var DrawerRenderer = function (props, ref) {
    var _a, _b;
    var hoverDelay;
    var defaultClasses = useStyles(props);
    var theme = core_1.useTheme();
    var _c = DrawerLayoutContextProvider_1.useDrawerLayout(), setPadding = _c.setPadding, setDrawerOpen = _c.setDrawerOpen;
    var _d = react_1.useState(false), hover = _d[0], setHover = _d[1];
    var 
    // Inheritable Props
    activeItemBackgroundColor = props.activeItemBackgroundColor, activeItemBackgroundShape = props.activeItemBackgroundShape, activeItemFontColor = props.activeItemFontColor, activeItemIconColor = props.activeItemIconColor, backgroundColor = props.backgroundColor, chevron = props.chevron, collapseIcon = props.collapseIcon, disableActiveItemParentStyles = props.disableActiveItemParentStyles, divider = props.divider, expandIcon = props.expandIcon, hidePadding = props.hidePadding, itemFontColor = props.itemFontColor, itemIconColor = props.itemIconColor, nestedBackgroundColor = props.nestedBackgroundColor, nestedDivider = props.nestedDivider, ripple = props.ripple, 
    // Drawer-specific props
    activeItem = props.activeItem, classes = props.classes, condensed = props.condensed, _e = props.noLayout, noLayout = _e === void 0 ? false : _e, open = props.open, openOnHover = props.openOnHover, openOnHoverDelay = props.openOnHoverDelay, onItemSelect = props.onItemSelect, _f = props.sideBorder, sideBorder = _f === void 0 ? false : _f, variantProp = props.variant, width = props.width, 
    // Other MUI Drawer Props
    drawerProps = __rest(props, ["activeItemBackgroundColor", "activeItemBackgroundShape", "activeItemFontColor", "activeItemIconColor", "backgroundColor", "chevron", "collapseIcon", "disableActiveItemParentStyles", "divider", "expandIcon", "hidePadding", "itemFontColor", "itemIconColor", "nestedBackgroundColor", "nestedDivider", "ripple", "activeItem", "classes", "condensed", "noLayout", "open", "openOnHover", "openOnHoverDelay", "onItemSelect", "sideBorder", "variant", "width"]);
    var variant = variantProp || 'persistent'; // to allow drawerLayout to override this
    var isRail = variant === 'rail';
    var isDrawerOpen = react_1.useCallback(function () {
        if (variant === 'persistent')
            return hover || open;
        if (variant === 'permanent' || variant === 'rail')
            return true;
        return open;
    }, [variant, hover, open]);
    var getHeader = react_1.useCallback(function () {
        return utilities_1.findChildByType(props.children, ['DrawerHeader'])
            .slice(0, 1)
            .map(function (child) { return react_1.default.cloneElement(child); });
    }, [props.children]);
    var getSubHeader = react_1.useCallback(function () {
        return utilities_1.findChildByType(props.children, ['DrawerSubheader'])
            .slice(0, 1)
            .map(function (child) { return react_1.default.cloneElement(child); });
    }, [props.children]);
    var getBody = react_1.useCallback(function () {
        return utilities_1.findChildByType(props.children, ['DrawerBody'])
            .slice(0, 1)
            .map(function (child) {
            return react_1.default.cloneElement(child, {
                // Inherited Props
                activeItemBackgroundColor: utilities_1.mergeStyleProp(activeItemBackgroundColor, child.props.activeItemBackgroundColor),
                activeItemBackgroundShape: utilities_1.mergeStyleProp(activeItemBackgroundShape, child.props.activeItemBackgroundShape),
                activeItemFontColor: utilities_1.mergeStyleProp(activeItemFontColor, child.props.activeItemFontColor),
                activeItemIconColor: utilities_1.mergeStyleProp(activeItemIconColor, child.props.activeItemIconColor),
                backgroundColor: utilities_1.mergeStyleProp(backgroundColor, child.props.backgroundColor),
                chevron: utilities_1.mergeStyleProp(chevron, child.props.chevron),
                collapseIcon: utilities_1.mergeStyleProp(collapseIcon, child.props.collapseIcon),
                disableActiveItemParentStyles: utilities_1.mergeStyleProp(disableActiveItemParentStyles, child.props.disableActiveItemParentStyles),
                divider: utilities_1.mergeStyleProp(divider, child.props.divider),
                expandIcon: utilities_1.mergeStyleProp(expandIcon, child.props.expandIcon),
                hidePadding: utilities_1.mergeStyleProp(hidePadding, child.props.hidePadding),
                itemFontColor: utilities_1.mergeStyleProp(itemFontColor, child.props.itemFontColor),
                itemIconColor: utilities_1.mergeStyleProp(itemIconColor, child.props.itemIconColor),
                nestedBackgroundColor: utilities_1.mergeStyleProp(nestedBackgroundColor, child.props.nestedBackgroundColor),
                nestedDivider: utilities_1.mergeStyleProp(nestedDivider, child.props.nestedDivider),
                ripple: utilities_1.mergeStyleProp(ripple, child.props.ripple),
            });
        });
    }, [
        activeItemBackgroundColor,
        activeItemBackgroundShape,
        activeItemFontColor,
        activeItemIconColor,
        chevron,
        collapseIcon,
        disableActiveItemParentStyles,
        divider,
        expandIcon,
        hidePadding,
        itemFontColor,
        itemIconColor,
        nestedBackgroundColor,
        nestedDivider,
        ripple,
        onItemSelect,
        props.children,
    ]);
    var getFooter = react_1.useCallback(function () {
        return utilities_1.findChildByType(props.children, ['DrawerFooter'])
            .slice(0, 1)
            .map(function (child) { return react_1.default.cloneElement(child); });
    }, [props.children]);
    var getDrawerContents = react_1.useCallback(function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        getHeader(),
        react_1.default.createElement("div", { style: { flexDirection: 'column', flex: '1 1 0px', display: 'flex' }, onMouseEnter: openOnHover
                ? function () {
                    hoverDelay = setTimeout(function () { return setHover(true); }, openOnHoverDelay);
                }
                : undefined, onMouseLeave: openOnHover
                ? function () {
                    clearTimeout(hoverDelay);
                    setHover(false);
                }
                : undefined },
            getSubHeader(),
            getBody(),
            getFooter()))); }, [setHover, openOnHover, openOnHoverDelay, getSubHeader, getBody, getFooter]);
    /* Default Drawer Sizes */
    var EXPANDED_DRAWER_WIDTH_DEFAULT = '22.5rem'; // theme.spacing(45);
    var COLLAPSED_DRAWER_WIDTH_DEFAULT = 'calc(1.5rem + 32px)'; //theme.spacing(7);
    // Determine the visible width of the drawer
    var getDrawerWidth = react_1.useCallback(function () {
        if (isRail)
            return condensed ? exports.RAIL_WIDTH_CONDENSED : exports.RAIL_WIDTH;
        if (isDrawerOpen())
            return width || EXPANDED_DRAWER_WIDTH_DEFAULT;
        return COLLAPSED_DRAWER_WIDTH_DEFAULT;
    }, [isRail, condensed, theme, isDrawerOpen, width]);
    // Get the width of the content inside the drawer - if the drawer is collapsed, content maintains its size in order to clip
    var getContentWidth = react_1.useCallback(function () {
        if (isRail)
            return condensed ? exports.RAIL_WIDTH_CONDENSED : exports.RAIL_WIDTH;
        return width || EXPANDED_DRAWER_WIDTH_DEFAULT;
    }, [isRail, condensed, width, theme]);
    // Update the drawer layout padding when the drawer changes
    react_1.useEffect(function () {
        if (!noLayout) {
            setPadding(variant === 'temporary' ? 0 : getDrawerWidth());
            setDrawerOpen(isDrawerOpen());
        }
    }, [variant, noLayout, isDrawerOpen, getDrawerWidth]);
    return (react_1.default.createElement(core_1.Drawer, __assign({ ref: ref }, drawerProps, { variant: variant === 'temporary' ? variant : 'permanent', open: isDrawerOpen(), classes: {
            root: clsx_1.default(defaultClasses.root, classes.root, (_a = {},
                _a[defaultClasses.expanded] = isDrawerOpen(),
                _a[classes.expanded] = isDrawerOpen() && classes.expanded,
                _a)),
            paper: clsx_1.default(defaultClasses.paper, classes.paper, (_b = {},
                _b[defaultClasses.sideBorder] = sideBorder,
                _b[classes.sideBorder] = sideBorder && classes.sideBorder,
                _b)),
        }, style: Object.assign({
            width: getDrawerWidth(),
        }, drawerProps.style) }),
        react_1.default.createElement(DrawerContext_1.DrawerContext.Provider, { value: {
                open: isDrawerOpen(),
                variant: variant,
                condensed: condensed,
                activeItem: activeItem,
            } },
            react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.content, classes.content), style: { width: getContentWidth() } }, getDrawerContents()))));
};
/**
 * [Drawer](https://pxblue-components.github.io/react/?path=/info/components-drawer--get-read-me-story) component
 *
 * The `<Drawer>` component is a wrapper around the [Material UI Drawer](https://material-ui.com/api/drawer/) that adds specific PX Blue functionality and styling. It is used to organize content (typically navigation links) in a collapsible side panel.
 *
 * The PX Blue Drawer includes helper components for `<DrawerHeader>`, `<DrawerSubheader>`, `<DrawerBody>`, `<DrawerNavGroup>`, `<DrawerNavItem>`, `<DrawerRailItem>`, `<DrawerFooter>`, and `<DrawerLayout>` to help organize the content.
 */
exports.Drawer = react_1.default.forwardRef(DrawerRenderer);
exports.Drawer.displayName = 'PXBlueDrawer';
// @ts-ignore
exports.Drawer.propTypes = __assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { activeItem: prop_types_1.default.string, classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        content: prop_types_1.default.string,
        expanded: prop_types_1.default.string,
        paper: prop_types_1.default.string,
        sideBorder: prop_types_1.default.string,
    }), condensed: prop_types_1.default.bool, noLayout: prop_types_1.default.bool, onItemSelect: prop_types_1.default.func, open: prop_types_1.default.bool.isRequired, openOnHover: prop_types_1.default.bool, openOnHoverDelay: prop_types_1.default.number, sideBorder: prop_types_1.default.bool, variant: prop_types_1.default.oneOf(['persistent', 'permanent', 'temporary', 'rail']), width: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]) });
exports.Drawer.defaultProps = {
    classes: {},
    openOnHover: true,
    sideBorder: false,
    variant: 'persistent',
    condensed: false,
    openOnHoverDelay: 500,
};
